import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {Link} from 'react-router-dom'
import './index.css'

class TrendingRoute extends Component {
  state = {
    trendingVideos: [],
    apiStatus: 'INITIAL',
  }

  componentDidMount() {
    this.getTrendingVideos()
  }

  getTrendingVideos = async () => {
    this.setState({apiStatus: 'IN_PROGRESS'})
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/videos/trending'
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    try {
      const response = await fetch(url, options)
      if (response.ok) {
        const data = await response.json()
        const updated = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          channel: each.channel,
          viewCount: each.view_count,
          publishedAt: each.published_at,
        }))
        this.setState({trendingVideos: updated, apiStatus: 'SUCCESS'})
      } else {
        this.setState({apiStatus: 'FAILURE'})
      }
    } catch {
      this.setState({apiStatus: 'FAILURE'})
    }
  }

  renderTrendingVideos = () => {
    const {trendingVideos} = this.state
    return (
      <>
        {/* Nav items list */}
        <ul className="nav-items-list">
          <li key="home">
            <Link to="/">Home</Link>
          </li>
          <li key="trending">
            <Link to="/trending">Trending</Link>
          </li>
        </ul>

        {/* Videos list */}
        <ul className="videos-list">
          {trendingVideos.map(each => (
            <li key={each.id} className="video-card">
              <Link to={`/videos/${each.id}`} className="video-link">
                <img
                  src={each.thumbnailUrl}
                  alt="video thumbnail"
                  className="thumbnail"
                />
                <p className="title">{each.title}</p>
                <p>{each.channel.name}</p>
                <p>
                  {each.viewCount} views • {each.publishedAt}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </>
    )
  }

  renderLoader = () => (
    <div data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height={50} width={50} />
    </div>
  )

  render() {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case 'IN_PROGRESS':
        return this.renderLoader()
      case 'SUCCESS':
        return this.renderTrendingVideos()
      case 'FAILURE':
        return <p>Failed to load trending videos</p>
      default:
        return null
    }
  }
}

export default TrendingRoute
